import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CanLeaveComponent } from './can-leave.component';
import { DialogComponent } from './components/dialog/dialog.component';

@NgModule({
    declarations: [CanLeaveComponent, DialogComponent],
    imports: [CommonModule],
    exports: [CanLeaveComponent, DialogComponent]
})
export class CanLeaveModule {}
